import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { authService } from '../../services/authService';
import { FaUserCircle, FaUserEdit, FaSignOutAlt, FaChevronDown, FaUserShield, FaPiggyBank } from 'react-icons/fa';

export const UserMenu: React.FC = () => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleLogout = async () => {
    await authService.signOutUser();
    navigate('/login');
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-x-3 p-1 rounded-lg hover:bg-gray-100 transition-colors"
      >
        <FaUserCircle size={28} className="text-gray-600" />
        <span className="text-sm font-medium text-gray-700 hidden md:block">{user?.displayName}</span>
        <FaChevronDown size={14} className={`text-gray-600 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20 border">
          <div className="px-4 py-3 border-b">
            <p className="text-sm font-semibold text-gray-700">{user?.displayName}</p>
            <p className="text-xs text-gray-600 truncate">{user?.email}</p>
          </div>
          <Link
            to="/profile"
            onClick={() => setIsOpen(false)}
            className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <FaUserEdit className="mr-3 text-gray-600" /> 프로필보기
          </Link>
          {isAdmin && (
            <>
              <Link
                to="/admin"
                onClick={() => setIsOpen(false)}
                className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaUserShield className="mr-3 text-blue-600" /> 관리자 페이지
              </Link>
              <Link
                to="/carryover-funds"
                onClick={() => setIsOpen(false)}
                className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                <FaPiggyBank className="mr-3 text-green-600" /> 이월예산관리
              </Link>
            </>
          )}
          <button
            onClick={handleLogout}
            className="w-full text-left flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            <FaSignOutAlt className="mr-3 text-gray-600" /> 로그아웃
          </button>
        </div>
      )}
    </div>
  );
};